var _path, _line;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIncomingCall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 8,
    viewBox: "0 0 7 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.501893 7.04347C0.525901 7.31857 0.768373 7.52211 1.04347 7.49811L5.52643 7.10688C5.80153 7.08287 6.00508 6.8404 5.98107 6.5653C5.95706 6.2902 5.71459 6.08666 5.43949 6.11066L1.45464 6.45842L1.10688 2.47357C1.08287 2.19847 0.840397 1.99492 0.565301 2.01893C0.290204 2.04294 0.0866559 2.28541 0.110664 2.56051L0.501893 7.04347ZM0.956647 6.27398L0.617047 6.67852L1.38295 7.32148L1.72255 6.91694L0.956647 6.27398Z",
    fill: "black"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1.61589,
    y1: 6.67991,
    x2: 6.61589,
    y2: 0.679908,
    stroke: "#060606"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncomingCall);
export default __webpack_public_path__ + "static/media/incomingCall.e215a78ef193995bee230d4985a7a46f.svg";
export { ForwardRef as ReactComponent };